import React, {FC} from 'react';
import {classNames} from "@modules/casting/String";
import {ParagraphType} from "@components/text/TextTypes";


const Description: FC<ParagraphType> = ({className, ...props}) => <p {...props}
    className={classNames('text-sm text-gray-500 -mt-0.5', className)}
/>;
export default Description;